import React, { useEffect } from 'react';
import { Form } from 'react-final-form';
import { useParams } from 'react-router';

import CommonModal from '../../../components/common-modal/CommonModal';
import { useProject } from '../../../context/ProjectContext';
import EditTagsFormInner from './EditTagsFormInner';
import validate from '../../../utils/validate';
import editTagsFormValidation from './validation';

function EditTagsModal({ isOpen, onClose, tags, contentId }) {
  const { actions } = useProject();
  const { id: projectId } = useParams();

  const initialValues = {
    tags: tags,
  };

  const handleSubmit = async (values) => {
    await actions('editTags', { contentId, tags: values.tags });
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      actions('searchTags', { id: projectId, query: '' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <Form
        initialValues={initialValues}
        keepDirtyOnReinitialize
        onSubmit={handleSubmit}
        subscription={{ submitting: true, pristine: true }}
        validate={(values) => validate(values, editTagsFormValidation())}
        render={({ handleSubmit }) => <EditTagsFormInner onSubmit={handleSubmit} onCancel={onClose} />}
      />
    </CommonModal>
  );
}

export default EditTagsModal;
